import Vue from 'vue'
import App from './App.vue'
import router from './router'
import api from './api'

// i18n
import { i18n, recomputeDocumentTitle } from './locales'

// 引入全局样式
import './styles/variables.css'

// 引入 Vant 组件
import {
  Button,
  Field,
  NavBar,
  Icon,
  Popup,
  Cell,
  CellGroup,
  Loading,
  Toast,
  Grid,
  GridItem,
  Overlay
} from 'vant'
import 'vant/lib/index.css'

// 注册 Vant 组件
Vue.use(Button)
Vue.use(Field)
Vue.use(NavBar)
Vue.use(Icon)
Vue.use(Popup)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Loading)
Vue.use(Toast)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Overlay)

// 注册API到Vue原型
Vue.prototype.$api = api

Vue.config.productionTip = false

// Router title hook (i18n) + scroll to top
router.afterEach(() => {
  recomputeDocumentTitle(router)
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
})

recomputeDocumentTitle(router)

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

